export const NON_PROFIT_SITE_CHOICE = { value: 'non_profit', label: 'Non-profit' };

export const BLOG_OR_PERSONAL_CHOICE = { value: 'blog_or_personal', label: 'Blog or Personal' };

export const SITE_INDUSTRY_CHOICES = [
  { value: 'e_commerce', label: 'E-commerce' },
  { value: 'saas', label: 'SaaS' },
  { value: 'marketplace', label: 'Marketplace' },
  { value: 'consulting', label: 'Consulting' },
  { value: 'media', label: 'Media' },
  BLOG_OR_PERSONAL_CHOICE,
  { value: 'education', label: 'Education' },
  { value: 'community', label: 'Community' },
  NON_PROFIT_SITE_CHOICE,
  { value: 'other', label: 'Other' },
];
